/**
 * What the CLIENT sees. Internally this is all "temp" — throwaway experiments,
 * see ./README.md — but a report author picking one from the Add Widget list
 * should not have to wonder whether "Temp" means unfinished or unsafe.
 *
 * Its own module, not index.js, because the ConfigForm needs it too and
 * index.js already imports the ConfigForm — a cycle that would resolve to
 * undefined depending on which module the bundler reaches first.
 */
export const CUSTOM_WIDGET_LABEL = "Custom Widget";
